import React, { memo, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Stack,
  Button,
  Icon,
  Typography,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Switch,
} from "investira.react.components";
import usePerfil from "../../hooks/usePerfil";
import useEntidade from "../../hooks/useEntidade";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import services from "../../services";
import { validators } from "investira.sdk";

const CustodianteActions = memo((props) => {
  const { hasCid } = props;
  const { state, actions } = useCarteirasContext();

  console.log("state", state);

  const [open, setOpen] = useState(false);
  // Estado local para controlar os switches (update otimista)
  const [switchStates, setSwitchStates] = useState({});

  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { usuarioPrioridade } = usePerfil();
  const { config } = useEntidade();

  const CustodianteCarteiraId = state.custodiante_carteira_id;
  const xSearchParams = new URLSearchParams(location.search);
  const xCid = xSearchParams.get("cid");

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const xCarteiraId = params.id;
  const xCarteiraConfig = state.carteira_config;

  // Determina o valor baseado nos dados originais
  // Se carteira_config for null ou undefined, exibe como ativo (true)
  // Caso contrário, usa o valor de custodiante_conferencia
  let xChecked;
  if (switchStates[xCarteiraId] !== undefined) {
    // Se existe estado local (após interação do usuário), usa ele
    xChecked = switchStates[xCarteiraId];
  } else {
    // Se não existe estado local, calcula baseado nos dados originais
    if (xCarteiraConfig === null || xCarteiraConfig === undefined) {
      xChecked = true; // Quando carteira_config é null, exibe como ativo
    } else {
      xChecked = Boolean(xCarteiraConfig?.custodiante_conferencia ?? false);
    }
  }

  const handleConferenciaCarteira = (pData = {}) => {
    services.carteiras.modify(
      pData,
      (rRes) => {
        return rRes;
      },
      (rErr) => {
        props.responseErrorHandling(rErr);
        return rErr;
      },
      () => {}
    );
  };

  if (
    !config?.custodiante_conferencia ||
    validators.isNull(CustodianteCarteiraId)
  ) {
    return null;
  }

  return (
    <>
      <Stack direction="column" spacing={0}>
        <Stack>
          <Typography variant="caption" color="textSecondary">
            Visualizar:
          </Typography>
        </Stack>
        <Stack direction="row" gap={1}>
          <Button
            disabled={props.disabledButtons}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="eye" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={() => {
              if (hasCid) {
                navigate(`/carteiras/${xCid}`);
              } else {
                navigate(
                  `/carteiras/${CustodianteCarteiraId}?cid=${params.id}`
                );
              }
            }}
          >
            {hasCid ? "Carteira" : "Carteira Custodiante"}
          </Button>
          {!hasCid && (
            <Stack flexGrow={0}>
              <Tooltip title={`Configurações Carteira`}>
                <IconButton
                  color="primary"
                  size="small"
                  onClick={handleDialogOpen}
                >
                  <Icon iconName="gear" size={24} />
                </IconButton>
              </Tooltip>
            </Stack>
          )}
        </Stack>
      </Stack>
      <Dialog open={open} maxWidth="xs" fullWidth onClose={handleDialogClose}>
        <DialogTitle>Configurações Carteira</DialogTitle>
        <DialogContent>
          <Stack direction="column" spacing={2}>
            <Stack direction="row" flexGrow={1} justifyContent="space-between">
              <Typography variant="body2">
                Conferência com Custodiante
              </Typography>
              <Switch
                checked={xChecked}
                onChange={(pEvent) => {
                  const xNewValue = pEvent.target.checked;
                  const xOldValue = xChecked;

                  // Update otimista: atualiza o estado imediatamente
                  setSwitchStates((xPrev) => ({
                    ...xPrev,
                    [xCarteiraId]: xNewValue,
                  }));

                  // Chama o serviço de atualização
                  handleConferenciaCarteira(
                    {
                      carteira_id: xCarteiraId,
                      carteira_config: {
                        custodiante_conferencia: xNewValue,
                      },
                    },
                    (rRes) => {
                      // Sucesso: mantém o novo valor
                    },
                    (rErr) => {
                      // Erro: faz rollback para o valor anterior
                      setSwitchStates((xPrev) => ({
                        ...xPrev,
                        [xCarteiraId]: xOldValue,
                      }));
                    }
                  );
                }}
                size="small"
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            type="button"
            color="primary"
            onClick={handleDialogClose}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default CustodianteActions;
